import PresentationApi from '@/api/presentation'
import FolderApi from '@/api/folder'
import cookie, { HAS_FOLDER_COOKIE } from '@/services/cookie'

let searchRequestId = 0

const setSelectedSearchByAction = ({ commit }, payload) => {
  commit('setSelectedSearchBy', payload)
}

const searchPresentationsAndFoldersAction = async ({ commit, state, rootGetters }, params = {}) => {
  const currentRequestId = ++searchRequestId

  const payload = rootGetters['multipleSessions/canInvitePresenterToFolder']
    ? { ...params, batchShareAsPresenter: true }
    : params

  try {
    const [folders, presentationsRes] = await Promise.all([
      FolderApi.searchFolders(payload),
      PresentationApi.searchPresentations(payload),
    ])

    if (currentRequestId !== searchRequestId) return false

    if (folders?.length > 0) {
      cookie.setValue(HAS_FOLDER_COOKIE, true)
    }

    const { presentations, numberOfPresentationPages } = presentationsRes
    const nextPresentations = params.page === 1
      ? presentations
      : [...state.presentations, ...presentations]

    commit('setFolders', folders)
    commit('setCurrentFolderDepth', null)
    commit('setBreadcrumbsMultipleLevelsArray', [])
    commit('setCurrentFolder', null)
    commit('setPresentations', nextPresentations)
    commit('setNumberOfPresentationPages', numberOfPresentationPages)

    return true
  } catch (error) {
    if (currentRequestId !== searchRequestId) return false
    throw error
  }
}

export default {
  setSelectedSearchByAction,
  searchPresentationsAndFoldersAction,
}
